import React from "react";
import styled from "styled-components";
import { SurveySegment, stringUtil } from "../../../../../../amorg-common";
import { ToggleChip } from "../../../../../../designSystem/Chip";
import { CountAvatar } from "../../../../../../designSystem/avatar/CountAvatar";

type SegmentListChipProps = {
    identifier: string,
    segments: SurveySegment[],
    selected: boolean,
    showIcons?:boolean,
    answerCount?:number,
    onClick?: (identifier: string, selected: boolean) => void,
};
export function SegmentListChip (props: SegmentListChipProps): JSX.Element
{
    function handleOnClick ()
    {
        if (props.onClick)
            props.onClick(props.identifier, !props.selected);
    }


    return (
        <ToggleChip selected={props.selected} onClick={props.onClick ? handleOnClick : undefined}>

            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                {props.segments.map((s, index) =>
                
                    <ValueContainer key={props.identifier + '-' + index} title={s.value}>
                        {stringUtil.capTextLength(s.value, 20)}
                    </ValueContainer>
                    
                )}
                {props.answerCount !== undefined &&
                    <CountAvatar count={props.answerCount} size="16px" />
                }
            </div>
        </ToggleChip>
    );
}
const ValueContainer = styled.div`
    
    padding: 0px 5px;
    &:last-child{
        border-right: none;
    }
`;

